<template>
  <div class="terms_condition">
    <vx-card id="terms_condition">
      <div class="vx-row">
        <!-- ck editor -->
        <div class="vx-col w-full">
          <ckeditor :editor="editor" v-model="editorData" :config="editorConfig"></ckeditor>
        </div>

        <!-- btn -->
        <div class="vx-col w-full mt-5 text-right">
          <vs-button class="mb-2" id="add-reward-setup" type="relief" @click="updateTermsConditionConfirmation">Save</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  name: 'TermsCondition',

  data() {
    return {
      loading: false,
      editor: ClassicEditor,
      editorData: null,
      editorConfig: {
        placeholder: 'Enter Terms and Condition Here'
      }
    }
  },

  mounted() {
    this.getTermCondition()
  },

  methods: {
    getTermCondition() {
      this.loading = true
      this.$store
        .dispatch('setting/getTermCondition')
        .then((res) => {
          this.editorData = res.data.value
          this.loading = false
        })
        .catch(({ message }) => {
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    updateTermsConditionConfirmation() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure, you want to update ?',
        accept: () => this.updateTermsCondition(),
        acceptText: 'Yes'
      })
    },

    updateTermsCondition() {
      this.loading = true
      this.$store
        .dispatch('setting/updateTermsCondition', { tnc: this.editorData })
        .then(({ message }) => {
          this.editorData = null
          this.loading = false

          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })

          this.getTermCondition()
        })
        .catch(({ message }) => {
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#terms_condition',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#terms_condition > .con-vs-loading')
      }
    }
  }
}
</script>

<style lang="scss">
.con-vs-loading {
  position: absolute;
}
</style>